export default "assets/images/icons/arrow-acede064.svg";